import defaultTheme from "./default";
import { createMuiTheme } from "@material-ui/core";

const overrides = {
	typography: {
		h1: {
			fontSize: "3rem",
			fontFamily: "League Spartan",
		},
		h2: {
			fontSize: "2rem",
			fontFamily: "League Spartan",
		},
		h3: {
			fontSize: "1.64rem",
			fontFamily: "League Spartan",
		},
		h4: {
			fontSize: "1.5rem",
			fontFamily: "League Spartan",
		},
		h5: {
			fontSize: "1.285rem",
			fontFamily: "League Spartan",
		},
		h6: {
			fontSize: "1.142rem",
			fontFamily: "League Spartan",
		},
		body1: {
			fontFamily: "Glacial Indifference",
			fontSize: "1rem",
		},
		body2: {
			fontFamily: "Glacial Indifference",
			fontSize: "0.875rem",
		},
	},
};

export default {
	default: createMuiTheme({ ...defaultTheme, ...overrides }),
};
